module.exports = __webpack_public_path__ + "img/logo.598db777.png";